import { useQuery } from "@tanstack/react-query";
import { adminSearchService } from "../../../services/adminSearch";
import { useAdminSearchStore } from "../store/adminSearchStore";

export function useAdminSearchInvites() {
  const { invitesState } = useAdminSearchStore();
  const { filters: invitesFilters, pagination } = invitesState;

  const queryKey = [
    "adminSearchInvites_key",
    {
      senderName: invitesFilters.senderName,
      invitee: invitesFilters.invitee,
      inviteeName: invitesFilters.inviteeName,
      status: invitesFilters.status,
      page: pagination.page,
      limit: pagination.limit,
    },
  ];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const filters = {};
      if (invitesFilters.senderName)
        filters.senderName = invitesFilters.senderName;
      if (invitesFilters.invitee) filters.invitee = invitesFilters.invitee;
      if (invitesFilters.inviteeName)
        filters.inviteeName = invitesFilters.inviteeName;
      if (invitesFilters.status) filters.status = invitesFilters.status;

      const res = await adminSearchService.adminSearchInvites({
        page: pagination.page,
        limit: pagination.limit,
        filters,
      });
      return {
        invites: res.invites || [],
        total: res.total || 0,
      };
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
